import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AvisContext } from "../context/AvisContext";
import { AuthorsUtils, AvisUtils } from "../../../utils";

export function NavigateUser() {
  const navigate = useNavigate();
  const { ctxRightsHolder, portalKind } = useContext(AvisContext);

  useEffect(() => {
    switch (portalKind.portalType) {
      case "authors": {
        navigate(AuthorsUtils.getStartPagePath(ctxRightsHolder));
        break;
      }
      case "blank-media":
      case "licensees": {
        navigate(AvisUtils.getStartPagePath());
        break;
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
}
